<template>
    <b-modal
      id="resource-modal"
      class="resource-modal"
      size="lg"
      centered
      @hide="handleHide"
      no-close-on-esc
    >
      <template #modal-title>
        <div class="addtask-from-title pb-3">
          Edit Quarterly Resource Report
        </div>
      </template>
  
      <div>
        <b-form @submit.prevent="$emit('submit')">
          <b-form-group label="Projects Added" label-cols="3" label-align-sm="left" label-class="fw-bold fs-5">
            <b-col cols="12">
              <b-form-input v-model.number="editFields.projects_added" type="number" :min="0" />
            </b-col>
          </b-form-group>
  
          <b-form-group label="Projects Closed" label-cols="3" label-align-sm="left">
            <b-col cols="12">
              <b-form-input v-model.number="editFields.projects_closed" type="number" :min="0" />
            </b-col>
          </b-form-group>
  
          <b-form-group label="Dedicated Devs Added" label-cols="3" label-align-sm="left">
            <b-col cols="12">
              <b-form-input v-model.number="editFields.dedicated_devs_added" type="number" :min="0" />
            </b-col>
          </b-form-group>
  
          <b-form-group label="Dedicated Devs Closed" label-cols="3" label-align-sm="left">
            <b-col cols="12">
              <b-form-input v-model.number="editFields.dedicated_devs_closed" type="number" :min="0" />
            </b-col>
          </b-form-group>
  
          <b-form-group label="Notes" label-cols="3" label-align-sm="left">
            <b-col cols="12">
              <b-form-textarea v-model="editFields.notes" rows="3" />
            </b-col>
          </b-form-group>
  
          <div class="text-right">
            <b-button type="submit" variant="primary">Save</b-button>
          </div>
        </b-form>
      </div>
    </b-modal>
  </template>
  
  <script>
  export default {
    name: 'QuarterlyReportModal',
    props: {
      editFields: {
        type: Object,
        required: true,
      },
    },
    methods: {
      handleHide() {
        this.$emit('hide');
      },
    },
  };
  </script>
  